import { Box, Card, CardBody, Text } from '@chakra-ui/react';
import { IProductType } from '../../interfaces';
import Colors from '../../config/colors';
import CatalogIcon from '../../images/navbar/CatalogIcon';
import { useTranslation } from 'react-i18next';

interface Props {
    productType: IProductType;
}

export default function ProductTypeListItem({ productType }: Props) {
    const [t] = useTranslation();

    return (
        <Card
            direction={{ base: 'column', sm: 'row' }}
            overflow="hidden"
            variant="unstyled"
            boxShadow="rgba(68, 98, 136, 0.25) 0px 3px 12px"
            borderRadius="0px"
            backgroundImage={process.env.PUBLIC_URL + '/images/categories/background_spotlight.jpg'}
            backgroundSize={'cover'}>
            <CardBody
                display="flex"
                alignItems="center"
                padding="20px 15px 20px 15px"
                justifyContent="space-between">
                <Box padding="0px">
                    <Text fontSize="14px" fontWeight="300" color="#fff">
                        {t(`steam-${productType.type}`)}
                    </Text>
                    <Text fontSize="14px" color={Colors.lightBlue}>
                    {t(`steam-${productType.type}-description`)}
                    </Text>
                </Box>

                <CatalogIcon color="#fff" />
            </CardBody>
        </Card>
    );
}
